export enum PermissionEnum {
    ROLE_CRM = 'ROLE_CRM',
    ROLE_TEAM = 'ROLE_TEAM',
    ROLE_MARKETING = 'ROLE_MARKETING',
    ROLE_REPORT = 'ROLE_REPORT',
    ROLE_CONFIG = 'ROLE_CONFIG',
    ROLE_DONATION = 'ROLE_DONATION',
}
